import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import WelcomePage from '@/pages/WelcomePage';

const RootEntry = () => {
  const { user } = useAuthStore();
  const isOpsMode = window.__OPS_MODE__ === true;

  if (isOpsMode) {
    return <Navigate to={user ? '/dispatch-sop' : '/login'} replace />;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <WelcomePage />;
};

export default RootEntry;
